import React from 'react'
import { useMediaQuery } from "@mui/material";
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import Footer from "../components/Footer";
import PageHeader from "../components/Auth/PageHeader";
import SubscribeForm from "../components/SubscribeForm";


const Subscribe = () => {
    const isMobile = useMediaQuery('(max-width: 990px)');
    return (
      <div>
          {!isMobile && <Header />} {/* Render Header only on desktop view */}
        {isMobile && <MobileHeader />}{" "}
        {/* Render MobileHeader only on mobile view */}
        {/* <PageHeader
          title="Sign In"
          breadcrumbs={[{ label: "Home", link: "/" }, { label: "Contact Us" }]}
        /> */}
          <SubscribeForm />
        <Footer />
      </div>
  )
}

export default Subscribe
